import {
  Box,
  Button,
  Modal as CSDModal,
  SpaceBetween,
} from "@cloudscape-design/components-themed";

import { useAppSelector, useAppDispatch } from "../../../app/hook";
import { dismissModal } from "./modal-slice";
import MultilineText from "../MultilineText";

/*
 * モーダル
 */
const Modal = () => {
  const {
    visible,
    title,
    positiveBtn,
    negativeBtn,
    content,
    positiveFn,
    negativeFn,
  } = useAppSelector((state) => state.modal);
  const dispatch = useAppDispatch();

  /**
   * ネガティブボタンを押下するイベント関数
   */
  const onClickNegativeBtnHandler = () => {
    if (negativeFn) negativeFn();
    dispatch(dismissModal());
  };

  /**
   * ポジティブボタンを押下するイベント関数
   */
  const onClickPositiveBtnHandler = () => {
    positiveFn();
    dispatch(dismissModal());
  };

  /**
   * モーダルクローズ関数
   * @returns void
   */
  const onDismissHandler = () => dispatch(dismissModal());

  return (
    <CSDModal
      visible={visible}
      onDismiss={onDismissHandler}
      closeAriaLabel="Close modal"
      size="large"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xxl">
            <Button variant="link" onClick={onClickNegativeBtnHandler}>
              {negativeBtn}
            </Button>
            <Button variant="primary" onClick={onClickPositiveBtnHandler}>
              {positiveBtn}
            </Button>
          </SpaceBetween>
        </Box>
      }
      header={title}
    >
      {content && typeof content === "string" ? (
        <MultilineText content={content} />
      ) : (
        content ?? <></>
      )}
    </CSDModal>
  );
};

export default Modal;
